import {
  useQueryCreditPackListAsMember,
  useQueryCreditPackListAsPublic,
} from "@gymflow/api";
import useGymflowModels from "apps/portal/src/store";
import { useContext,useMemo  } from "react";

import { AuthenticationContext } from "../../../../providers/authentication/AuthenticationContext";
import { CreditPackType } from "./HostedPagesCreditPackFilterPopover";

export const useCreditPackAvailableTabs = () => {
  const { userId: id } = useContext(AuthenticationContext);
  const { api } = useGymflowModels();
  const classPackQueryOptions: Parameters<
    typeof useQueryCreditPackListAsPublic
  >[0] = {
    api,
    opts: {
      hasActivityCategory: true,
      status: "ACTIVE",
      size: 1,
      page: 0,
    },
  };
  const classPackAsPublic = useQueryCreditPackListAsPublic(
    classPackQueryOptions,
    { enabled: !id },
  );
  const classPackAsMember = useQueryCreditPackListAsMember(
    classPackQueryOptions,
    { enabled: !!id },
  );
  const { data: classPack } = !!id ? classPackAsMember : classPackAsPublic;
  const appointablePackQueryOptions: Parameters<
    typeof useQueryCreditPackListAsPublic
  >[0] = {
    api,
    opts: {
      hasAppointableCategory: true,
      status: "ACTIVE",
      size: 1,
      page: 0,
    },
  };
  const appointablePackAsPublic = useQueryCreditPackListAsPublic(
    appointablePackQueryOptions,
    { enabled: !id },
  );
  const appointablePackAsMember = useQueryCreditPackListAsMember(
    appointablePackQueryOptions,
    { enabled: !!id },
  );
  const { data: appointablePack } = !!id
    ? appointablePackAsMember
    : appointablePackAsPublic;
  const tabs = useMemo(() => {
    const result = [] as CreditPackType[];
    if (classPack && classPack?.content.length > 0) {
      result.push("CLASSES");
    }
    if (appointablePack && appointablePack?.content.length > 0) {
      result.push("APPOINTMENTS");
    }
    return result;
  }, [appointablePack, classPack]);
  return tabs;
};
